import * as React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";

const styles = (theme) => ({
  card: {
    width: "100%",
    backgroundColor: theme.palette.grey[50],
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    marginBottom: 12,
    "&.invisible": {
      boxShadow: "none",
      background: "transparent",
    },
  },
  wrapper: {
    padding: "20px",
    width: "100%",
  },
  tag: {
    width: "100%",
    textAlign: "center",
    backgroundColor: theme.palette.grey[300],
    padding: "6px",
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.primary.main,
    "&.invisible": {
      display: "none",
    },
  },
});

const TitledCard = ({ classes, children, titleText, hideDataBoxStyle }) => (
  <Card className={`${classes.card} ${hideDataBoxStyle && "invisible"}`}>
    <Grid container>
      {titleText && (
        <Grid
          item
          className={`${classes.tag} ${hideDataBoxStyle && "invisible"} `}
        >
          {titleText}
        </Grid>
      )}
    </Grid>
    <div className={classes.wrapper}>{children}</div>
  </Card>
);

TitledCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  hideDataBoxStyle: PropTypes.bool,
};

TitledCard.defualtProps = {
  hideDataBoxStyle: false,
};

export default withStyles(styles)(TitledCard);



// WEBPACK FOOTER //
// ./src/components/UI/TitledCard.jsx